export function getGrossPrice(amount: number) {
  const commissionPercentage = JSON.parse(
    localStorage.getItem("user") || ""
  ).commissionPercentage;
  if (!commissionPercentage) return null;

  return amount / (1 - commissionPercentage / 100);
}
